import { memo, useContext } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { Bot } from 'lucide-react'
import { ExecutionContext } from '../../../components/flow-nodes/shared/ExecutionContext'

// Handle 样式常量
const HANDLE_STYLE = {
  width: 12,
  height: 12,
  background: '#94a3b8',
  border: '2px solid #64748b',
} as const

const HANDLE_STYLE_ACTIVE = {
  ...HANDLE_STYLE,
  background: '#3b82f6',
  border: '2px solid #1d4ed8',
} as const

// 自定义节点组件：Agent 节点
export const AgentNode = memo(({ data, selected, id }: NodeProps) => {
  const { activeNodeId, visitedNodeIds } = useContext(ExecutionContext)
  const isActive = activeNodeId === id
  const isVisited = visitedNodeIds.has(id)
  
  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-white border-2 min-w-[160px] transition-all duration-300 ${
      isActive 
        ? 'border-blue-500 ring-4 ring-blue-400/50 shadow-xl scale-105 animate-pulse' 
        : selected 
          ? 'border-blue-500 ring-2 ring-blue-500/20 shadow-xl' 
          : isVisited 
            ? 'border-blue-300 ring-2 ring-blue-200/50' 
            : 'border-slate-200'
    }`}>
      <Handle
        type="target"
        position={Position.Left}
        style={selected || isActive ? HANDLE_STYLE_ACTIVE : HANDLE_STYLE}
      />
      
      <div className="flex items-center gap-2">
        <div className={`p-1.5 rounded-md transition-colors duration-300 ${isActive ? 'bg-blue-500' : 'bg-blue-100'}`}>
          <Bot className={`h-4 w-4 ${isActive ? 'text-white' : 'text-blue-600'}`} />
        </div>
        <div>
          <div className="font-medium text-sm">{data.label}</div>
          <div className="text-xs text-slate-500">{data.role || '待配置'}</div>
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Right}
        style={selected || isActive ? HANDLE_STYLE_ACTIVE : HANDLE_STYLE}
      />
    </div>
  )
})

AgentNode.displayName = 'AgentNode'